import { CheckInStatusEnum } from 'app/shared/enums/check-in-status-type.enum';
import { ContactList, ContactVM } from '../back-office-admin-common/contact.models';
import { GridSchema } from '../common/grid-schema.model';
import { LocationFullDTO } from '../../../../shared/models/location.model';
import { OnlineStoreVM, OnlineStoreDto } from './storePointOfSale.model';
import { ActiveChannelDTO } from 'app/shared/models/channel.model';
import { CustomerFullDTO } from '../customer/customer.model';

export interface GridPosSchema<T> extends GridSchema<T> {
  checkInStatus?: number | null,
  customerId?: number | null,
  city?: string | null,
  tier?: number | null,
  locationType?: number | null,
  onlineStore?: number | null,
  withoutStore?: boolean | null,
}


export class PointOfSaleDetailVM {
  checkInStatus?: CheckInStatusEnum;
  customerToApprove?: boolean;
  customerName?: string;
  customerId?: number;
  externalId: string;
  locationId: number;
  id: number;
  name: string;
  location: LocationFullDTO;
  onlineStores: OnlineStoreVM[];
  contacts: ContactVM[];
  lastModificationTime: string;
  lastBusinessUserModificationTime?: Date;
  lastBusinessUserModifierId?: number;
  creationTime: string;
  contactList: ContactList;
  creatorId: number;
  lastModifierId: number;
  storePointOfSales: OnlineStoreDto[];
  useCustomerBillingLocation: boolean;

  orders?: string;
  total?: number;
  activatedStoreChannels: ActiveChannelDTO[];
  alternativeVat?: string;
  alternativeGlnNumber?: string;

  draftOrdersCount: number;
  summerStockLimit: number;
  summerStartMonth: number;
  summerStartDay: number;
  winterStockLimit: number;
  winterStartMonth: number;
  winterStartDay: number;
  useNameInOrderHeader: boolean;
  isFromBilling?: boolean;
  customer?: CustomerFullDTO;
  nameAndLocation: string;
  constructor(init?: Partial<PointOfSaleDetailVM>) {
    Object.assign(this, init);
    if (!this.location) this.location = new LocationFullDTO();
    if (!this.onlineStores) this.onlineStores = [];
  }
}



